import {
  CheckIfGroupIsFinishedRule,
  CheckIfTheTicketGroupCanBeSoldRule,
  CheckRatingBasedTicketAccessRule,
  CheckSalesOpeningRule,
  ConcatStatusSessionInDateTicketRule,
  IdentifyTicketWithCarouselIdRule,
  RemoveHalfTicketsRule,
  SortTicketsByDateAndClosingAndStockRule,
  SortTicketsByOrderRule
} from '../implementations';
import { RuleSetStrategy } from '../strategies/RuleSetStrategy';
import { Rule } from '../types/Rule';

export class BahiaFutebolRuleSetStrategy implements RuleSetStrategy {
  getRules(): Rule[] {
    return [
      new CheckSalesOpeningRule(),
      new CheckIfGroupIsFinishedRule(),
      new IdentifyTicketWithCarouselIdRule(),
      new SortTicketsByDateAndClosingAndStockRule(),
      new CheckIfTheTicketGroupCanBeSoldRule(),
      new ConcatStatusSessionInDateTicketRule(),
      new RemoveHalfTicketsRule(),
      new SortTicketsByOrderRule(),
      new CheckRatingBasedTicketAccessRule(),
    ];
  }
}
